import { render, staticRenderFns } from "./trainingsReport.vue?vue&type=template&id=b6c46a50&scoped=true"
import script from "./trainingsReport.vue?vue&type=script&lang=js"
export * from "./trainingsReport.vue?vue&type=script&lang=js"
import style0 from "./trainingsReport.vue?vue&type=style&index=0&id=b6c46a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c46a50",
  null
  
)

export default component.exports